import axios from 'axios';
import authService from './authService';

const API_URL = '/api/';

class ApartmentService {
  /**
   * Get list of apartments in active union
   */
  async getApartments(params = {}) {
    const response = await axios.get(API_URL + 'apartments/', {
      headers: authService.authHeader(),
      params
    });
    return response.data;
  }

  /**
   * Get apartment by ID
   */
  async getApartment(id) {
    const response = await axios.get(API_URL + `apartments/${id}/`, {
      headers: authService.authHeader()
    });
    return response.data;
  }

  /**
   * Create new apartment
   */
  async createApartment(data) {
    const response = await axios.post(API_URL + 'apartments/', data, {
      headers: authService.authHeader()
    });
    return response.data;
  }

  /**
   * Update apartment
   */
  async updateApartment(id, data) {
    const response = await axios.put(API_URL + `apartments/${id}/`, data, {
      headers: authService.authHeader()
    });
    return response.data;
  }

  /**
   * Delete apartment
   */
  async deleteApartment(id) {
    const response = await axios.delete(API_URL + `apartments/${id}/`, {
      headers: authService.authHeader()
    });
    return response.data;
  }

  /**
   * Add owner to apartment
   */
  async addOwner(apartmentId, userId) {
    const response = await axios.post(
      API_URL + 'apartment-ownerships/',
      { apartment: apartmentId, owner: userId },
      { headers: authService.authHeader() }
    );
    return response.data;
  }

  /**
   * Remove owner from apartment
   */
  async removeOwner(ownershipId) {
    await axios.delete(API_URL + `apartment-ownerships/${ownershipId}/`, {
      headers: authService.authHeader()
    });
  }

  /**
   * Invite an owner by email (creates ownership or sends invitation email)
   */
  async inviteOwner(apartmentId, email) {
    const response = await axios.post(
      API_URL + `apartments/${apartmentId}/invite-owner/`,
      { email },
      { headers: authService.authHeader() }
    );
    return response.data;
  }

  /**
   * Add a tenant by email (creates tenancy or sends invitation)
   */
  async addTenant(apartmentId, email) {
    const response = await axios.post(
      API_URL + `apartments/${apartmentId}/add-tenant/`,
      { email },
      { headers: authService.authHeader() }
    );
    return response.data;
  }

  /**
   * Remove (end) a tenancy
   */
  async removeTenant(apartmentId, tenancyId) {
    await axios.delete(
      API_URL + `apartments/${apartmentId}/remove-tenant/${tenancyId}/`,
      { headers: authService.authHeader() }
    );
  }

  /**
   * Revoke a pending invitation
   */
  async revokeInvitation(apartmentId, invitationId) {
    await axios.delete(
      API_URL + `apartments/${apartmentId}/revoke-invitation/${invitationId}/`,
      { headers: authService.authHeader() }
    );
  }

  /**
   * Fetch invoice PDF as blob (for opening in browser tab via object URL)
   */
  async previewInvoice(apartmentId, year, month) {
    const response = await axios.get(
      `/api/apartments/${apartmentId}/preview-invoice/`,
      {
        headers: authService.authHeader(),
        params: { year, month },
        responseType: 'blob',
      }
    );
    return response.data; // Blob
  }

  /**
   * Send invoice PDF by email to apartment owners
   */
  async sendInvoice(apartmentId, year, month) {
    const response = await axios.post(
      `/api/apartments/${apartmentId}/send-invoice/`,
      { year, month },
      { headers: authService.authHeader() }
    );
    return response.data;
  }

  /**
   * Get utility types for active union
   */
  async getUtilityTypes() {
    const response = await axios.get(API_URL + 'utility-types/', {
      headers: authService.authHeader()
    });
    return response.data;
  }

  /**
   * Get bills for an apartment
   */
  async getBills(params = {}) {
    const response = await axios.get(API_URL + 'bills/', {
      headers: authService.authHeader(),
      params
    });
    return response.data;
  }

  /**
   * Get payments for an apartment
   */
  async getPayments(params = {}) {
    const response = await axios.get(API_URL + 'payments/', {
      headers: authService.authHeader(),
      params
    });
    return response.data;
  }
}

const apartmentService = new ApartmentService();
export default apartmentService;
